function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.7 6a13 13 0 0 0-1.4-.6l-.1-.1S15 3 13.7 2.3C12.4 1.9 10 .5 7.7.6c-2 0-3.1.4-3.5.5-.5.2-.9.3-.3.6l1.8 1c1.4 1 3 1.9 3.8 2 .7.2 1.9.5 3.3.5 1.7 0 2.5.7 2.7 1-.3-.5-1.4-.9-3-.8a10 10 0 0 1-3.3-.2c-1.4-.4-2.8-1-4-1.7a9 9 0 0 0-1 .4c-.5.2-.9.6-.3.7.4.2 4.4 1.7 5.6 1.8.7 0 1.7 0 3-.2 1.6-.3 2.4.3 2.6.6-.5.7-.8 1.6-.7 2.6-5.6-1-7.3-1.6-8.6-1.8-2.1-.4-4.9 1.6-5.2 4-.2 1.4 0 2.7.9 3.9.9 1.3 2 2.4 2.2 2.7v1c0 .5.5.9.8.9L8 21l4.8 1.7v-.5c.1-.4-.1-1.4-1.3-1.7l-2.3-.8c-.2 0 0 0 .2-.3.5-.4 1-1 1.2-1.5 1-2.3-.3-4.3-.3-4.3s.8 1 1 2.4c.4 2-.8 3.4-.8 3.4l.8.2 5-5.5c.4-.4 1.1-.7 1.5-.8a17 17 0 0 0 3.1-1.4c.4-.3 1-1.2 1-1.4.2-.3.3-.6.3-1l-.6-1s-1-1.9-2-2.5ZM6 21.4c-.2.1-.3.6 0 .9.4.1 1.6-.5 1.6-.5l-1.2-.4s-.2-.1-.4 0Z",
  fill: "#666"
});

function SvgLoggi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgLoggi);
export default __webpack_public_path__ + "static/media/loggi.fe020759.svg";
export { ForwardRef as ReactComponent };